// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/segmented-control/style/index.less
// module id = 190
// module chunks = 0